function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Children } from 'react';
import { findDOMNode, createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { func } from '../util';
import findNode from './utils/find-node';
var makeChain = func.makeChain;

var Gateway = /*#__PURE__*/function (_Component) {
  _inherits(Gateway, _Component);

  var _super = _createSuper(Gateway);

  function Gateway() {
    var _this;

    _classCallCheck(this, Gateway);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "saveChildRef", function (ref) {
      _this.child = ref;
    });

    return _this;
  }

  _createClass(Gateway, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.containerNode = this.getContainerNode(this.props);
      this.forceUpdate();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.containerNode = this.getContainerNode(nextProps);
    }
  }, {
    key: "getContainerNode",
    value: function getContainerNode(props) {
      var targetNode = findNode(props.target);
      return findNode(props.container, targetNode);
    }
  }, {
    key: "getChildNode",
    value: function getChildNode() {
      return findDOMNode(this.child);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.containerNode) {
        return null;
      }

      var children = this.props.children;
      var child = children ? Children.only(children) : null;

      if (!child) {
        return null;
      }

      if (typeof child.ref === 'string') {
        throw new Error('Can not set ref by string in Gateway, use function instead.');
      }

      child = React.cloneElement(child, {
        ref: makeChain(this.saveChildRef, child.ref)
      });
      return createPortal(child, this.containerNode);
    }
  }]);

  return Gateway;
}(Component);

_defineProperty(Gateway, "propTypes", {
  children: PropTypes.node,
  container: PropTypes.any,
  target: PropTypes.any
});

_defineProperty(Gateway, "defaultProps", {
  container: function container() {
    return document.body;
  }
});

export { Gateway as default };